import { SELECT_DROPDOWN_MENU_ITEM } from "../../../../enums/Request/leader.requests.types";

export const selectDropdownMenuItemAction = (event, element, stateProperty) => {
    return {
        type: SELECT_DROPDOWN_MENU_ITEM,
        payload: [event, element, stateProperty],
    };
};